import { type TipoDomandaDTO } from '@framework/api-client/api/inquiries/schemas/tipoDomandaDTO.ts';
import { useAuth } from '@framework/auth/state/AuthSlice.tsx';
import { InquiryItemBase } from '@framework/common-web/ui/inquiry/cover/inquiry/InquiryItemBase.tsx';
import { LinkButton } from '@framework/ui/components/button/LinkButton.tsx';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { CreateSubmissionButton } from '../../../../components/inquiries/list/CreateSubmissionButton.tsx';

export interface IInquiryItemProps {
  inquiry?: TipoDomandaDTO;
}

export function InquiryItem(props: IInquiryItemProps) {
  const { inquiry } = props;

  const { isLogged } = useAuth();

  const location = useLocation();
  const { t } = useTranslation();

  if (!inquiry) return null;

  return (
    <InquiryItemBase inquiry={inquiry}>
      {isLogged ? (
        <CreateSubmissionButton inquiry={inquiry} />
      ) : (
        <LinkButton
          type="primary"
          to={{ pathname: '/login', state: { from: location } }}
          block
          size="large"
        >
          {t('domanda-copertina.accedi', 'Accedi')}
        </LinkButton>
      )}
    </InquiryItemBase>
  );
}
